import * as z from "zod";

export const navMenuItemSchema = z.object({
  id: z.number(),
  title: z.string(),
  description: z.string(),
  url: z.string(),
  target: z.string(),
  parent_id: z.number(),
  current: z.boolean(),
  class: z.string(),
  get children() {
    return z.array(navMenuItemSchema);
  },
});
export type NavMenuItem = z.infer<typeof navMenuItemSchema>;
